class RegearHeaderSearch extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    const input = this.querySelector('#AiSearchInput');
    const panel = this.querySelector('.predictive-search-form__content-wrapper');
    const form = this.querySelector('form');
    if (!input || !panel || !form) return;

    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.dataset.ready = 'true';
    const stickySection = this.closest('.shopify-section');
    if (stickySection) {
      const updateHeight = () => document.body.style.setProperty('--ai-sticky-search-height', `${stickySection.getBoundingClientRect().height}px`);
      this.heightObserver = new ResizeObserver(updateHeight);
      this.heightObserver.observe(stickySection);
      updateHeight();
    }

    this.panelObserver = new MutationObserver(() => {
      const currentPanel = this.querySelector('.predictive-search-form__content-wrapper');
      if (this.dataset.searchOpen !== 'true' && currentPanel && !currentPanel.hidden) currentPanel.hidden = true;
    });
    this.panelObserver.observe(this, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true });
    this.setOpen(false);
    this.addEventListener('focusin', (event) => {
      if (event.target.matches('#AiSearchInput')) this.setOpen(true);
    }, { signal });
    this.addEventListener('input', (event) => {
      if (event.target.matches('#AiSearchInput')) this.setOpen(Boolean(event.target.value.trim()));
    }, { signal, capture: true });
    this.addEventListener('keydown', (event) => {
      if (event.target.matches('#AiSearchInput') && event.key === 'Escape') this.setOpen(false);
    }, { signal });
    this.addEventListener('click', (event) => {
      if (event.target.closest('.predictive-search__reset-button, .predictive-search-form__content-wrapper a')) this.setOpen(false);
    }, { signal });
    document.addEventListener('pointerdown', (event) => {
      if (!this.contains(event.target)) this.setOpen(false);
    }, { signal });
    form.addEventListener('submit', () => this.setOpen(false), { signal });
  }

  setOpen(open) {
    this.dataset.searchOpen = String(open);
    const panel = this.querySelector('.predictive-search-form__content-wrapper');
    if (panel) panel.hidden = !open;
    this.querySelector('#AiSearchInput')?.setAttribute('aria-expanded', String(open));
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.heightObserver?.disconnect();
    this.panelObserver?.disconnect();
    this.controller = null;
    this.heightObserver = null;
    this.panelObserver = null;
    delete this.dataset.ready;
    delete this.dataset.searchOpen;
  }
}

if (!customElements.get('regear-header-search')) customElements.define('regear-header-search', RegearHeaderSearch);
